<section class="relative flex flex-col items-center gap-6">
  <div
    class="absolute h-full w-full bg-[radial-gradient(#d1d5db_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_85%,transparent_100%)]"
  ></div>
  <div class="z-10">
    <tui-badge appearance="neutral" iconStart="@tui.store" size="xl">
      App Store Publishing
    </tui-badge>
  </div>
  <div class="z-10 flex flex-col items-center gap-14">
    <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
      @defer {
        Publish to app stores<br /><span
          [roughNotation]="{
            animate: true,
            animationDelay: 500,
            strokeWidth: 3,
            iterations: 4,
            type: 'underline',
            color: 'var(--tui-background-accent-2)',
            padding: 2,
          }"
          >with one click</span
        >
      } @placeholder {
        Publish to app stores<br />with one click
      }
    </h1>
    <p class="w-full text-balance text-center text-xl leading-snug md:w-3/4">
      <span class="hidden md:block"
        >Stop juggling App Store Connect, Google Play Console, and Fastlane
        configuations. One dashboard, two stores, zero complexity. Just connect,
        configure once, and publish anytime.</span
      >
      <span class="md:hidden"
        >Publish to TestFlight, App Store, and Google Play from one simple
        dashboard.</span
      >
    </p>
    <div class="flex flex-col items-center gap-3">
      <div class="flex space-x-4">
        <a
          iconEnd="@tui.arrow-right"
          size="l"
          tuiButton
          type="button"
          [href]="consoleBaseUrl"
          target="_blank"
          data-umami-event="app-store-publishing-hero-start-free-button"
        >
          Get started
        </a>
        <a
          appearance="secondary"
          size="l"
          tuiButton
          type="button"
          [href]="bookingUrl"
          target="_blank"
          data-umami-event="app-store-publishing-hero-booking-demo-button"
        >
          Book a demo
        </a>
      </div>
      @if (statistics.data(); as data) {
        <p class="flex items-center gap-1.5 text-sm text-gray-600">
          <span>📦</span>
          <span
            ><b>{{ data.lastMonthAppDeployments | number }} App Submissions</b>
            processed last month</span
          >
        </p>
      }
    </div>
  </div>
</section>
